export default __webpack_public_path__ + "assets/fire.e884fe01.gif";